import React, { useState } from "react";
import { Alert, Button } from "react-bootstrap";
import { useSelector } from "react-redux";
import { setVw_Nagar_KhandaList, setVw_Nagar_KhandaMessage } from "redux/actions";
import { RootState } from "redux/reducers";
import { useAppDispatch } from "redux/store";
import { getVw_Nagar_Khanda } from "services/vw_nagar_khandaService";
import Layout from "template";
import { Constant } from "template/Constant";
import { Vw_Nagar_KhandaTable } from "./table";

export const Vw_Nagar_Khanda: React.FC = () => {
  const dispatch = useAppDispatch();
  const rData = useSelector((state: RootState) => state.vw_nagar_khanda);
  const [row, setRow] = useState(undefined);
  const [action, setAction] = useState('');
  const getData = (page, pageSize, searchKey) => {
    getVw_Nagar_Khanda(page, pageSize, searchKey).then((response) => {
      if (response && response.records) {
        dispatch(setVw_Nagar_KhandaList({ pageNo: page, pageSize: pageSize, list: response.records, totalCount: response.totalCount, searchKey: searchKey }));
      } else {
		dispatch(setVw_Nagar_KhandaMessage("No Record Found"));
      }
    })
  }

  const handleRowEdit = (rowData) => {
    setRow(rowData);
    dispatch(setVw_Nagar_KhandaMessage(''));
    setAction('edit');
  }
  return (
    <Layout>
      <div className="container-fluid">
        {/* <div className="d-sm-flex align-items-center justify-content-between mb-4">
          <h1 className="h3 mb-0 text-gray-800">Vw_Nagar_Khanda</h1>
        </div> */}
        <div className="d-flex flex-column min-vh-100">
          {rData.message ?
            <Alert variant={Constant.defaultAlertVarient} className="alert-dismissible fade">{rData.message}
              <Button type="button" className="close" data-dismiss="alert" aria-label="Close" onClick={() => dispatch(setVw_Nagar_KhandaMessage(''))}>
                <span aria-hidden="true">&times;</span>
              </Button>
            </Alert> : null}
         
            <Vw_Nagar_KhandaTable handleRowEdit={handleRowEdit} hideShowForm={setAction} getData={getData} />
        </div>

      </div>
    </Layout >
  );
};

